function quantityShop () {
   $('<div class="quantity-nav"><div class="quantity-button quantity-down">-</div><div class="quantity-button quantity-up">+</div></div>').insertAfter('div.quantity input');

   $('<div class="lineBreak"></div>').insertBefore('.single_add_to_cart_button');
   
   $('.quantity').each(function() {
      var spinner = $(this);
      var input = spinner.find('input[type="number"]');
      var btnUp = spinner.find('.quantity-up');
      var btnDown = spinner.find('.quantity-down');
      var min = input.attr('min');
      var max = input.attr('max');

      if(max == null) {
         max = 0;
      } else {
         max = input.attr('max');
      }
      btnUp.click(function() {
         var min = input.attr('min');
         var max = input.attr('max');
         // var text = "5";
         // $(input).valF(text);
         var oldValue = parseFloat(input.val());
         if (oldValue >= max && max > 0) {
            var newVal = oldValue;

         } else {
            var newVal = oldValue + 1;

         }
         spinner.find("input").val(newVal);
         spinner.find("input").trigger("change");

      });


      btnDown.click(function() {
         var min = input.attr('min');
         var max = input.attr('max');
         var oldValue = parseFloat(input.val());
         if (oldValue <= min) {
            var newVal = oldValue;
         } else {
            var newVal = oldValue - 1;
         }
         spinner.find("input").val(newVal);
         spinner.find("input").trigger("change");

      });

   });
}


module.exports = function () {
   quantityShop ();
};
